import script from "./LeaveRequestView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveRequestView.vue?vue&type=script&setup=true&lang=js"

import "./LeaveRequestView.vue?vue&type=style&index=0&id=2b53853e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b53853e"]])

export default __exports__